//wait to load the page content
window.addEventListener("load", function () {
  document.body.classList.add("loaded");
});

jQuery(document).ready(function ($) {
  // Open Menu
  $(".menu-toggle").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $("body").toggleClass("body-navigation-active");
    $("#site-navigation").toggleClass("navigation-active");
    $("#site-navigation")
      .find("a")
      .click(function () {
        $(".menu-toggle").trigger("click");
      });
  });

  $(window).scroll(function () {
    var $this = $(this),
      $head = $("#masthead");
    if ($this.scrollTop() > 120) {
      $head.addClass("is-sticky");
    } else {
      $head.removeClass("is-sticky");
    }
  });

  $(".lglt-section-image-content .btn-scrollto").click(function () {
    console.log($(this).attr('data-scroll'))
    const slideNextCont = $($(this).attr('data-scroll')).offset().top;
    $("html, body").scrollTop(slideNextCont);
  });

  //CAROUSEL HP
  //Shift the order of the controller
  $(".lglt-carousel--navs .lglt-carousel--nav:first-child").insertAfter(
    ".lglt-carousel--navs .lglt-carousel--nav:last-child"
  );
  $(".lglt-carousel--slides").slick({
    asNavFor: ".lglt-carousel--navs",
    arrows: false,
    fade: true,
  });

  $(".lglt-carousel--navs").slick({
    asNavFor: ".lglt-carousel--slides",
    autoplay: true,
    //autoplaySpeed: 10000,
    arrows: false,
    dots: true,
    fade: true,
  });
  $(".lglt-carousel--nav").on("click", function () {
    $(".lglt-carousel--navs").slick("slickNext");
  });

  //GENERAL CAROUSEL Cards
  $(".wp-block-lgtl-gallery-wrapper.lgtl-slick-cards").slick({
    arrows: false,
    dots: true,
    speed: 300,
    infinite: true,
    slidesToShow: 1,
    //variableWidth:true,
    //centerMode: true,
  });

  //GENERAL CAROUSEL Images
  $(".wp-block-lgtl-gallery-wrapper.lgtl-slick-images").slick({
    arrows: false,
    dots: true,
    speed: 300,
    infinite: true,
    variableWidth: true,
    centerMode: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
  });
  //GENERAL CAROUSEL Awards
  $(".wp-block-lgtl-gallery-wrapper.lgtl-slick-awards").slick({
    arrows: false,
    dots: true,
    speed: 300,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  //slider news
  $(".post-list-slider").slick({
    arrows: true,
    dots: false,
    speed: 300,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  //CLIENTS TOGGLE
  const $clientsAll = $(".clients-all");
  const $clientsActive = $(".clients-active");
  $clientsAll.add($clientsActive).on("click", function (event) {
    event.preventDefault();
    if ($(this).hasClass("is-style-outline")) {
      //If it's not selected
      $clientsAll.toggleClass("is-style-outline");
      $clientsActive.toggleClass("is-style-outline");
      $(
        ".wp-block-lgtl-contenitore .wp-block-lgtl-spazio:not(.lgtl-active)"
      ).toggle();
    }
  });

  //ACCORDION
  $(".lgtl-accordion--wrapper").each(function () {
    if (
      ($(this).attr("data-areallopen")==='true' &&
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) || $(this).attr("data-areallopen")==='false')
    ) {
      $(this).accordion({
        header: ".lgtl-accordion--title",
        active: false,
        collapsible: false,
        heightStyle: "content",
        create: function (event, ui) {
          if ($(this).attr("data-isopen") > 0) {
            $(this).accordion(
              "option",
              "active",
              parseInt($(this).attr("data-isopen")) - 1
            );
          }
        },
      });
    }
  });

  $(".footer__accordion").accordion({
    header: "h3",
    active: false,
    collapsible: true,
    heightStyle: "content",
  });
  //ACCORDION COLUMNS CONTENT
  if ($(".is-accordion").length) {
    var contentAccrodion = $(
      ".is-accordion .wp-block-lgtl-group[data-show-id]"
    );
    var linksAccordion = $(".is-accordion ul li");
    var current = linksAccordion
      .filter(":first")
      .find("a")
      .addClass("currentAccordion")
      .attr("href")
      .substring(1);
    contentAccrodion.not(`[data-show-id=${current}]`).hide();
    linksAccordion.find("a").on("click", function (event) {
      event.preventDefault();
      linksAccordion.find(`a.currentAccordion`).toggleClass("currentAccordion");
      $(this).toggleClass("currentAccordion");
      var next = $(this).attr("href").substring(1);
      contentAccrodion
        .filter(`[data-show-id=${current}]`)
        .fadeOut(100, function () {
          contentAccrodion.filter(`[data-show-id=${next}]`).fadeIn(100);
          current = next;
        });
    });
  }

  //get position navigation page to fix on top
  //$('.lglt-menuOdContent__menu')
  if ($(".lglt-menuOdContent__container").length) {
    var eTop = $(".lglt-menuOdContent__container").offset().top;

    $(window).scroll(function () {
      var posElTop = eTop - $(window).scrollTop();
      if (posElTop <= 0) {
        $(".lglt-menuOdContent").addClass("lglt-menuOdContent__fixed");
      } else {
        $(".lglt-menuOdContent").removeClass("lglt-menuOdContent__fixed");
      }
    });
  }

  //Fancybox managment
  $(".entry-content figure a").each(function () {
    $(this)
      .attr("data-fancybox", "gallery")
      .attr("data-srcset", $(this).children(":first").attr("srcset"));
  });
  $('[data-fancybox="gallery"]').fancybox({
    loop: true,
    arrows: true,
    infobar: false,
    toolbar: true,
    idleTime: 3,
    buttons: ["close"],
    baseClass: "lgtl-fancybox",
    protect: true,
    animationEffect: "zoom",
    transitionEffect: "slide",
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
        '<svg width="48" height="48" xmlns="http://www.w3.org/2000/svg"><path d="M10 6.888l14 14 14-14 3.112 3.111-14 14.001 14 14-3.111 3.112-14.001-14-14 14-3.112-3.111 14-14.001-14-14 3.111-3.112z" fill="#00000F" fill-rule="nonzero"/></svg>' +
        "</button>",
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
        '<div><svg width="48" height="48" xmlns="http://www.w3.org/2000/svg"><path d="M19.163 39.953L2.18 23.105 19.163 6.258l2.75 2.772-12.22 12.124 36.26-.001v3.905H9.693L21.913 37.18l-2.75 2.772z" fill="#000" fill-rule="nonzero"/></svg></div>' +
        "</button>",
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
        '<div><svg width="48" height="48" xmlns="http://www.w3.org/2000/svg"><path d="M28.97 6.258l16.982 16.847L28.97 39.953l-2.75-2.772L38.44 25.057H2.18v-3.904h36.258L26.219 9.03l2.75-2.772z" fill="#000" fill-rule="nonzero"/></svg></div>' +
        "</button>",
    },
  });
  //Core team behaviour
  $(".lglt-team--person .lglt-team--info").click(function (e) {
    e.preventDefault();
    $(this).next(".lglt-team--person-modal").addClass("show");
  });
  $(".lglt-team--person .modal__close").click(function (e) {
    e.preventDefault();
    $(".lglt-team--person-modal").removeClass("show");
  });
  //Load more
  $("body").on("click", ".load_more a", function (e) {
    e.preventDefault();
    loadMorePosts();
  });
  //Modal form
  $('#form-modal .modal__close').click(function(e){
    e.preventDefault();
    $('#form-modal').addClass('modal-hide');
  });
  $("a[href='#show-modal']").click(function(e){
    e.preventDefault();
    $('#form-modal').removeClass('modal-hide');
  })
  //close modal on mail sent 
  document.addEventListener( 'wpcf7mailsent', function( event ) {
    setTimeout(() => {   $('#form-modal').addClass('modal-hide'); }, 5000);
  }, false );

  $(window).scroll(function () {
    if ($(".load_more a").length) {
      var linkLoadMore = $(".load_more a");
      var elHeight = linkLoadMore.outerHeight(true);
      var elPositionTop =
        $(linkLoadMore).offset().top -
        $(window).scrollTop() -
        $(window).height() +
        elHeight;
      if (elPositionTop < 0) {
        loadMorePosts();
      }
    }
  });

  var controllerPosts = new ScrollMagic.Controller();

  function loadMorePosts() {
    var link = $(".load_more a").attr("href");
    $(".load_more").html('<span class="loader">Loading...</span>');
    $.get(link, function (data, status) {
      var $post = $(".post-list__item", data);
      $(".list-ajax").append($post);

      var inner = $post.find(".animate-fadeintopPost");

      var tl = new TimelineMax();
      tl.fromTo(
        inner,
        0.5,
        { position: "relative", top: 0, opacity: 0 },
        { position: "relative", top: 0, opacity: 1 }
      );

      var scene = new ScrollMagic.Scene({
        triggerElement: inner,
        triggerHook: 0.8,
      })
        .setTween(tl)
        .reverse(false)
        .addTo(controllerPosts);
    });
    $(".load_more").load(link + " .load_more a");
  }

  $(".animate-fadeintopPost").each(function (i) {
    var inner = $(this);
    var tl = new TimelineMax();
    tl.fromTo(
      inner,
      0.5,
      { position: "relative", opacity: 0 },
      { position: "relative", opacity: 1 }
    );

    var scene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.8,
    })
      .setTween(tl)
      .reverse(false)
      .addTo(controllerPosts);
  });

  //video play

  $(document).on("click", "video", function () {
    if (this.paused) {
      $(this).closest(".wp-block-video").removeClass("icon-play");
    } else {
      $(this).closest(".wp-block-video").addClass("icon-play");
    }
  });
});

//counter
jQuery(
  (function ($, win) {
    $.fn.inViewport = function (cb) {
      return this.each(function (i, el) {
        function visPx() {
          var H = $(this).height(),
            r = el.getBoundingClientRect(),
            t = r.top,
            b = r.bottom;
          return cb.call(el, Math.max(0, t > 0 ? H - t : b < H ? b : H));
        }
        visPx();
        $(win).on("resize scroll", visPx);
      });
    };
  })(jQuery, window)
);

jQuery(function ($) {
  // DOM ready and $ in scope
  $(".lgtl-counter--number").inViewport(function (px) {
    // Make use of the `px` argument!!!
    // if element entered V.port ( px>0 ) and
    // if prop initNumAnim flag is not yet set
    //  = Animate numbers
    if (px > 0 && !this.initNumAnim) {
      this.initNumAnim = true; // Set flag to true to prevent re-running the same animation
      $(this)
        .prop("Counter", 0)
        .animate(
          {
            Counter: $(this).text(),
          },
          {
            duration: 1000,
            step: function (now) {
              $(this).text(Math.ceil(now));
            },
          }
        );
    }
  });
});
